// @ts-check
import React, { Component, Fragment } from "react"
import { BlockContextConsumer } from "../ContextProviders"
import BroadcastItem from "../broadcast/BroadcastItem"
import DefineBroadcast from "../broadcast/DefineBroadcast"
import { generateId } from "../broadcast/utils"
import DefineValidation from "../validation/DefineValidation"

/**
 * @augments {Component<{context: BlockContext, value: any} & Broadcast_Property>}
 */
class DefineProperty extends Component {
    static defaultProps = {
        tags: [],
    }
    componentWillMount() {
        const blockId = this.props.context.block.id

        const { name, tags, description, type } = this.props

        this.property = {
            id: generateId(blockId, "property", this.props.name),
            ownerBlockId: blockId,
            tags,
            name,
            description,
            type,
            channel: "property",
        }
        if (this.props.context.propertyStore.get(this.property.id) && this.props.onPersistedValue) {
            this.props.onPersistedValue(this.props.context.propertyStore.get(this.property.id))
        }
    }
    componentDidMount() {
        this.props.context.propertyStore.add(this.property.id, this.props.value)
    }
    componentWillUpdate(newProps) {
        if (newProps.value !== this.props.value) {
            this.props.context.propertyStore.add(this.property.id, newProps.value)
        }
    }
    componentWillUnmount() {
        this.props.context.propertyStore.add(this.property.id, undefined)
    }
    render() {
        return (
            <Fragment>
                <DefineBroadcast broadcast={this.property} />
                <BroadcastItem
                    id={this.property.id}
                    children={property => (
                        <BroadcastItem
                            name={property.published_name}
                            children={item =>
                                item &&
                                item.ownerBlockId !== this.property.ownerBlockId && (
                                    <DefineValidation
                                        severity="warning"
                                        name="DefineProperty.overriddenName"
                                        payload={{ target: item }}
                                        description={`property name ${
                                            property.published_name
                                        } is already taken`}
                                    />
                                )
                            }
                        />
                    )}
                />
            </Fragment>
        )
    }
}

DefineProperty.propTypes = {}

export default function DefinePropertyInContext(props) {
    return (
        <BlockContextConsumer>
            {context => <DefineProperty {...props} context={context} />}
        </BlockContextConsumer>
    )
}



// WEBPACK FOOTER //
// ./src/features/editor/properties/DefineProperty.js